import React from 'react';
import * as Scrivito from 'scrivito';

Scrivito.provideWidgetClass('ImageWidget', {
  attributes: {
    image: 'reference',
    alt: 'string',
  },
});

// ImageTag already sets width from the binary's metadata; height comes from
// the same place, so the browser can reserve the box (Lighthouse:
// "unsized-images"). Lazy: content images live in the page body, mostly far
// below the hero, and the browser still fetches lazy images near the
// viewport right away - the rest stop competing with first paint.
const ImageWidget = Scrivito.connect(({ widget }) => {
  const image = widget.get('image');
  const blob = image && image.objClass() === 'Image' ? image.get('blob') : null;
  const height = blob ? blob.raw().metadata().get('height') : undefined;

  return (
    <Scrivito.ImageTag
      content={widget}
      attribute="image"
      alt={widget.get('alt') || ''}
      className="img-responsive img-padding"
      style={{ maxWidth: '100%', display: 'block' }}
      height={typeof height === 'number' ? height : undefined}
      loading="lazy"
    />
  );
});

Scrivito.provideComponent('ImageWidget', ImageWidget);

Scrivito.provideEditingConfig('ImageWidget', {
  title: 'Image',
  properties: ['image', 'alt'],
  attributes: {
    image: { title: 'Image' },
    alt:   { title: 'Alt Text', description: 'Describe the image for screen readers and SEO.' },
  },
});

export default ImageWidget;
